import { Link, useLocation } from 'react-router-dom';
import './Breadcrumbs.css';

function Breadcrumbs() {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter(x => x);

    const breadcrumbNameMap = {
        'about': 'About',
        'contact': 'Contact',
        'privacy': 'Privacy Policy',
        'terms': 'Terms of Service',
        'dashboard': 'Dashboard',
        'notebook': 'Notebook',
        'ide': 'IDE',
        'calendar': 'Calendar',
    };

    return (
        <nav className="breadcrumbs" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            {pathnames.map((value, index) => {
                const to = `/${pathnames.slice(0, index + 1).join('/')}`;
                const isLast = index === pathnames.length - 1;

                return isLast ? (
                    <span key={to} className="breadcrumb-current">
                        {breadcrumbNameMap[value] || value}
                    </span>
                ) : (
                    <Link key={to} to={to}>
                        {breadcrumbNameMap[value] || value}
                    </Link>
                );
            })}
        </nav>
    );
}

export default Breadcrumbs;
